import React from 'react'

function Checkout() {
  return (
    <>
      <h1>Checkout</h1>
    </>
  )
}

export default Checkout
